class ArtikelPreis extends HTMLElement {
  connectedCallback() {

  }
}

if (!customElements.get("artikel-preis")) {
  customElements.define("artikel-preis", ArtikelPreis);
}
